import jobSearchService from '@/api/jobsearch.service'
import { mapResponseToJob } from './job-search.utils'

const actions = {
  getJobs(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobSearchService
        .getJobs(context, data)
        .then(response => {
          let jobs = response[0]

          if (data.activeTab === 'applications') {
            // applied jobs are stored in 3rd index of api response
            jobs = response[3]
            context.commit('appliedJobs', jobs)
          } else if (data.activeTab === 'bookmarks') {
            // applied jobs are stored in 5th index of api response
            jobs = response[5]
            context.commit('markedJobs', jobs)
          }

          // map the response to what we need for UI
          jobs = mapResponseToJob(jobs)

          // total-records is equal to number of items in jobs array
          let totalRecords = jobs.length

          if (data.activeTab === 'search') {
            // for the search tab, total-records comes from API
            if (response[1][0] && response[1][0].count) {
              totalRecords = response[1][0].count
            }
          } else {
            // for bookmarks/applications, we do it manually
            const start = (data.page - 1) * data.count
            let end = data.page * data.count
            if (totalRecords < end) {
              end = totalRecords
            }
            jobs = jobs.slice(start, end)
          }

          let pages = Math.ceil(totalRecords / data.count)

          context.commit('jobs', jobs)
          context.commit('totalRecords', totalRecords)
          context.commit('pages', pages)

          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getJobsNewApi(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobSearchService
        .getJobsNewApi(context, data)
        .then(response => {
          let jobs = response.SearchResult

          if (data.activeTab === 'applications') {
            // applied jobs are stored in 3rd index of api response
            jobs = response.Applied
            context.commit('appliedJobs', mapResponseToJob(jobs))
          } else if (data.activeTab === 'bookmarks') {
            // applied jobs are stored in 5th index of api response
            jobs = response.Marked
            context.commit('markedJobs', mapResponseToJob(jobs))
          }

          // map the response to what we need for UI
          jobs = mapResponseToJob(jobs)

          // total-records is equal to number of items in jobs array
          let totalRecords = jobs.length

          if (data.activeTab === 'search') {
            // for the search tab, total-records comes from API
            totalRecords = response.Count.length ? response.Count[0].count : jobs.length
          } else {
            // for bookmarks/applications, we do it manually
            const start = (data.page - 1) * data.count
            let end = data.page * data.count
            if (totalRecords < end) {
              end = totalRecords
            }
            jobs = jobs.slice(start, end)
          }

          let pages = Math.ceil(totalRecords / data.count)

          context.commit('jobs', jobs)
          context.commit('totalRecords', totalRecords)
          context.commit('pages', pages)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getApplications(context, data) {
    // this action creator is actually for candidate management
    // and should be moved from here
    var promise = new Promise((resolve, reject) => {
      jobSearchService
        .getApplications(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  markJob(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobSearchService
        .markJob(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  unmarkJob(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobSearchService
        .unmarkJob(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  navigatePage(context, page) {
    context.commit('page', page)
  },
  toggleSearchFilters(context, value) {
    context.commit('showFilters', value)
  },
}

export default actions
